export default () => {
  const accordionItems = document.querySelectorAll('.accordion__item');

  if (accordionItems.length > 0) {
    accordionItems.forEach(item => {
      const content = item.querySelector('.accordion__item__answer'); 

      item.addEventListener('click', () => {
        const isActive = item.classList.contains('is-active');

        accordionItems.forEach(otherItem => {
          if (otherItem !== item) {
            otherItem.classList.remove('is-active');
            const otherContent = otherItem.querySelector('.accordion__item__answer');
            otherContent.style.height = '0';
          }
        });

        item.classList.toggle('is-active');
        
        if (isActive) {
          content.style.height = '0';
        } else {
          const contentHeight = content.scrollHeight; 
          content.style.height = `${contentHeight + 10}px`;
        }
      });
    });
  }
}
